import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getCurrentRenderState } from './getCurrentRenderState';
import { getCustomDataForLogging } from './getCustomDataForLogging';
import { getTimestamp, now } from 'owa-datetime';
import { MAIL_LIST_VIEW } from 'data/lib/mini-app-constants/commonEventSourceConstants';
import { MutableRefObject } from 'react';
import { RSVP_RENDERED } from 'data/lib/mini-app-constants/commonEventSignalConstants';
import { RsvpContextObject } from 'mini-rsvp/lib/utils/RsvpContextObject';
import { RsvpRenderState } from '../schema/RsvpRenderState.types';

const DEFAULT_RSVP_RENDER_TIMEOUT = 600000; // Choosing a default rsvp render timeout as 10 mins

export const logRsvpRenderDatapoint = async (
    calEvent: CalendarEvent,
    meetingClientItem: ClientItem,
    lazyLoadTime: number,
    initialRenderTimestamp: number,
    previousRenderStateRef: MutableRefObject<RsvpRenderState>,
    partialRenderTimestamp: MutableRefObject<number>,
    fetchConflictingMeetingsFinished: boolean
) => {
    const previousRenderState = previousRenderStateRef?.current;

    const currentTime = getTimestamp(now());
    const renderTime = currentTime - initialRenderTimestamp;

    // No need to log datapoint if we've already logged the datapoint
    // or when the render time exceeds the timeout value
    if (
        previousRenderState === RsvpRenderState.CompleteRender ||
        renderTime > DEFAULT_RSVP_RENDER_TIMEOUT
    ) {
        return;
    }

    const currentRenderState = getCurrentRenderState(
        calEvent,
        fetchConflictingMeetingsFinished,
        previousRenderState
    );

    if (currentRenderState === RsvpRenderState.PartialRender) {
        previousRenderStateRef.current = currentRenderState;
        partialRenderTimestamp.current = getTimestamp(now());
    } else if (currentRenderState === RsvpRenderState.CompleteRender) {
        previousRenderStateRef.current = currentRenderState;

        const customData = await getCustomDataForLogging(
            meetingClientItem,
            calEvent,
            initialRenderTimestamp,
            partialRenderTimestamp?.current,
            lazyLoadTime
        );

        RsvpContextObject?.signal(RSVP_RENDERED, customData, {
            actionSource: MAIL_LIST_VIEW,
            isCore: true,
        });
    }
};
